goog.provide("shadow.js.shim.module$react_intersection_observer");
goog.provide("module$shadow_js_shim_module$react_intersection_observer");
shadow.js.shim.module$react_intersection_observer = shadow.js.nativeProvides["react-intersection-observer"] = shadow$bridge("react-intersection-observer");
module$shadow_js_shim_module$react_intersection_observer.default = shadow.js.shim.module$react_intersection_observer;
